// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3XguC","content":"GlobalSearch_content__1sH5Q"};